module.exports = "../../../../platform/assets/pageMainIcon/icon-zuzhi-2-red.svg";